import { render, staticRenderFns } from "./UploadContainer.vue?vue&type=template&id=1e9a6242&scoped=true"
import script from "./UploadContainer.vue?vue&type=script&lang=js"
export * from "./UploadContainer.vue?vue&type=script&lang=js"
import style0 from "./UploadContainer.vue?vue&type=style&index=0&id=1e9a6242&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9a6242",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip,QSpinnerIos,QTooltip});
